const MoneyFormat = new Intl.NumberFormat("en-GB", {
  maximumFractionDigits: 2,
});

const MoneyFormatCurrencyStyleFormatter = new Intl.NumberFormat("en-GB", {
  maximumFractionDigits: 2,
  style: "currency",
  currency: "GBP",
});

export const MoneyFormatCurrencyStyle = {
  format: (value: number) => {
    const formatted = MoneyFormatCurrencyStyleFormatter.format(value);
    return formatted.replace(/\.00$/, "");
  },
};

export const asMoney = (
  value: number,
  currency: boolean = false,
  allowZero: boolean = false,
): string => {
  if (allowZero && value === 0) {
    return "0";
  }
  if (value) {
    const formatter = currency ? MoneyFormatCurrencyStyle : MoneyFormat;
    const result = formatter.format(value);
    return result.replace(/£/g, "");
  }
  if (value === 0) {
    return "0";
  }
  return "";
};

export const inputToFloat = (input: any) => {
  if (input) {
    try {
      return parseFloat(
        input
          .toString()
          .replaceAll(",", "")
          .replaceAll("-", "")
          .replaceAll("£", "")
          .replaceAll(" ", ""),
      );
    } catch (error) {
      return parseFloat(input.toString());
    }
  }
  return input;
};
